import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Contract } from "@/types/contract";

interface PropertyInfoProps {
  contract: Contract;
  formatCurrency: (value: number | null | undefined) => string;
}

export function PropertyInfo({ contract, formatCurrency }: PropertyInfoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Property Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h3 className="font-semibold text-lg">{contract.title}</h3>
          {contract.property_address && (
            <p className="text-muted-foreground">{contract.property_address}</p>
          )}
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="font-medium">Property Value:</span>
            <p>{formatCurrency(contract.property_value)}</p>
          </div>
          <div>
            <span className="font-medium">Current Status:</span>
            <p className="capitalize">{contract.status}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}